import { Injectable } from '@angular/core';
import { FrontendConfigApi } from 'src/app/shared/api/frontend-config.api';

import { CompanyState } from 'src/app/shared/state/company.state';

import { catchError, map, Observable, of, throwError } from 'rxjs';
import { AppEnumMap, EnumItem } from '../interface/common.interface';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(
    private companyState: CompanyState,
    private frontendConfigApi: FrontendConfigApi
  ) {}

  /** Loads the property and order field configs for a report type, once. */
  getFieldConfig(reportType: string): Observable<boolean> {
    if (this.companyState.hasPropertyFieldConfig(reportType)) {
      return of(true);
    }

    return this.frontendConfigApi.getFieldConfigs(reportType).pipe(
      map(({ propertyField, orderField }) => {
        this.companyState.setPropertyFieldConfig(reportType, propertyField);
        this.companyState.setOrderFieldConfig(reportType, orderField);
        return true;
      }),
      catchError((error: Error) => {
        return throwError(() => error);
      })
    );
  }

  getEnumeration(reportType: string): Observable<boolean> {
    if (this.companyState.hasEnumConfig(reportType)) {
      return of(true);
    }

    return this.frontendConfigApi.getEnumeration(reportType).pipe(
      map((enums) => {
        this.companyState.setEnumConfig(reportType, this._formatAppEnumeration(enums));
        return true;
      }),
      catchError((error: Error) => {
        return throwError(() => error);
      })
    );
  }

  private _formatAppEnumeration(appEnums: AppEnumMap): AppEnumMap {
    const formattedEnum: any = {};
    Object.entries(appEnums).forEach(([key, valueList]: [string, EnumItem[]]) => {
      formattedEnum[key] = valueList.map((value: EnumItem) => {
        value.key = value.enumValue as string;
        value.displayValue = value.enumDisplayValue as string;
        return value;
      });
    });
    return formattedEnum as AppEnumMap;
  }
}
